/**
 * ЛИЧНЫЙ КАБИНЕТ (профиль пользователя) — задача 2026-09-12.
 *
 * ЖЁСТКИЕ РАМКИ ПОСТАНОВКИ (сводка Антона, 12:26):
 *
 * 1. ДЕСКТОПНАЯ ШАПКА: аватар КРУЖКОМ 96–120px, имя и MXID СПРАВА от
 *    кружка, НЕ поверх фото. Растянутая шапка Telegram — следствие
 *    мобильного жеста «тянуть вниз»; на десктопе её нет и не должно быть.
 *    Клик по кружку = лайтбокс во весь экран (свой, минимальный: фото
 *    на весь экран, закрытие кликом/Esc/крестиком — медиа-карусель из
 *    MediaViewer здесь не нужна, слайд один).
 *
 * 2. Разделов ровно ПЯТЬ, список ЗАКРЫТ, новых не придумывать:
 *      - Устройства
 *      - Мои файлы и медиа
 *      - Файлы и медиа, которыми со мной поделились
 *      - Уведомления
 *      - Оформление
 *    Отклонены Антоном и НЕ реализованы: Энергосбережение (11:37),
 *    Saved Messages / Recent Calls / Chat Folders (11:33).
 *
 * 3. «Изменить фото» — отдельная акцентная строка; разделы — карточки
 *    с иконкой и шевроном, текущее значение справа серым.
 *
 * ЧТО ЧЕСТНО УМЕЕТ КАЖДЫЙ РАЗДЕЛ (никаких кнопок-обманок):
 *  - Устройства (ПЕРЕДЕЛАНО 2026-09-12 17:52, поправка 17:58;
 *    ДОРАБОТКА 18:40; ПЕРЕДЕЛАНО 2026-09-13): устройство = «машина +
 *    клиент», имя человеческое («Mac · Chrome (веб)»); переименование
 *    (PUT /devices/{id}, UIA не требует); удаление ВНУТРИ приложения
 *    (DELETE /devices/{id} / MAS GraphQL), кнопка у КАЖДОГО устройства
 *    включая текущее (для текущего — подтверждение «это выход из
 *    аккаунта»); добавление — свой экран входа по коду (Device Code
 *    Flow, RFC 8628; сервер поддерживает).
 *  - Мои файлы и медиа / поделились со мной (ПЕРЕДЕЛАНО 2026-09-12
 *    17:54 + поиск 18:00): ОДИН пункт, внутри ДВА ТАБА «Медиа» (сетка
 *    превью через /thumbnail, клик — лайтбокс) и «Файлы» (список: значок
 *    типа, имя, размер, дата, комната, скачивание), вид из RoomTabs.
 *    Поиск по имени файла и подписи + фильтр по чату. Собраны из
 *    ЗАГРУЖЕННЫХ таймлайнов (см. шапку matrix/profile.ts). Серверного
 *    индекса файлов у Synapse нет (README п.2), поэтому раздел честно
 *    говорит об ограничении, а не притворяется полным архивом.
 *  - Уведомления: текущее состояние Notification.permission + способ
 *    его изменить. Значение справа серым — само разрешение.
 *  - Оформление: тёмной темы в клиенте нет (theme.ts: «закладка на
 *    тёмную тему», Антон: «в идеале да, но НЕ критично»). Раздел
 *    показывает честное «Светлая» и не предлагает переключатель,
 *    который ничего не переключает.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ ЭКРАН, А НЕ ДИАЛОГ: пять разделов с содержимым
 * (списки устройств/файлов) в диалоге 380px не живут; постановка —
 * полноценный «личный кабинет». Экран подменяет колонку комнаты,
 * список чатов остаётся на месте (как страница комнаты в RoomPage).
 *
 * ПРАВКА АНТОНА 12.09 12:26 (учтена):
 *  - вход в кабинет — свой аватар ВНИЗУ левой рельсы (самый нижний
 *    элемент, ниже «＋»); реализация — OwnRailAvatar в App.tsx;
 *  - ЛОГАУТ — ПОСЛЕДНЯЯ СТРОКА кабинета, после всех пяти разделов,
 *    красным, с подтверждением. Это ДЕЙСТВИЕ, а не шестой раздел —
 *    список разделов остаётся закрытым;
 *  - верхняя панель приложения удалена целиком, поэтому диагностика
 *    уведомлений (жившая в шапке) переехала в раздел «Уведомления» —
 *    текущее разрешение приходит пропом notifPermission.
 */
import { useEffect, useRef, useState, type CSSProperties, type ReactNode } from "react";
import type { MatrixClient } from "matrix-js-sdk";

import {
  collectFiles,
  currentDeviceLabel,
  deleteDevice,
  diffNewDevices,
  fetchOwnDevices,
  fetchOwnProfile,
  groupDevices,
  markDevicesSeen,
  renameDevice,
  setOwnAvatar,
  setOwnDisplayName,
  startDeviceCodeFlow,
  type DeviceCodeSession,
  type DeviceGroup,
  type DeviceInfo,
  type OwnProfile,
  type SharedFile,
} from "../matrix/profile";
import { humanError } from "../matrix/roomActions";
import { AVATAR_ACCEPT } from "../matrix/avatarImage";
import { useImagePicker, visuallyHiddenInput } from "./useImagePicker";
import { PickerNoteLine } from "./PickerNoteLine";
import { useAuthedMedia, useAuthedMediaBlob, useAuthedThumb } from "../matrix/media";
import { groupByMonth } from "../matrix/roomAttachments";
import { config } from "../config";
import {
  IconBell,
  IconCamera,
  IconCheck,
  IconChevronRight,
  IconClose,
  IconDevices,
  IconEdit,
  IconGlobe,
  IconImage,
  IconPalette,
  IconTrash,
  IconUsers,
} from "./icons";
import { LANGS, tf, useLang, useLocale, useT, useTF } from "../i18n";
import { Zoomable } from "./Zoomable";
import { NotificationControls } from "./NotificationControls";
import {
  color,
  colorOf,
  font,
  radius,
  space,
  applyTheme,
  readThemeMode,
  applyFontSize,
  readFontSizeMode,
  type FontSizeMode,
} from "./theme";

/** Диаметр кружка аватара в шапке. Постановка: 96–120px, берём середину. */
const AVATAR_SIZE = 112;

/** Какой раздел раскрыт. null — только карточки (вид списка). */
type OpenSection = "devices" | "myFiles" | "sharedFiles" | "notifications" | "appearance" | "language" | null;

export function ProfileView({
  client,
  notifPermission,
  onClose,
  onLogout,
  serverName,
  serverUrl,
  onSwitchServer,
}: {
  client: MatrixClient;
  /**
   * Текущее разрешение уведомлений из App (правка 12:26 п.3: верхняя
   * панель с диагностикой удалена, показывать состояние осталось только
   * здесь). Строкой, а не чтением Notification.permission внутри:
   * App уже следит за ответом браузера на запрос при заходе, и два
   * источника правды разошлись бы.
   */
  notifPermission?: string;
  onClose: () => void;
  /** Логаут (правка 12:26 п.2): последняя строка кабинета.
      Теперь асинхронный (25.09): внутри — завершение сессии в MAS,
      и LogoutRow ждёт результат, чтобы показать ошибку вместо тишины. */
  onLogout: () => void | Promise<void>;
  /** Читаемое имя текущего сервера: «Прод» / «Стенд» / хост. */
  serverName?: string;
  serverUrl?: string;
  /** Смена сервера — рядом с выходом, но ЭТО НЕ ВЫХОД: сессия остаётся. */
  onSwitchServer?: () => void;
}) {
  const [profile, setProfile] = useState<OwnProfile | null>(null);
  const t = useT();
  const [error, setError] = useState<string | null>(null);
  const [section, setSection] = useState<OpenSection>(null);
  /** Лайтбокс аватара во весь экран (клик по кружку). */
  const [lightbox, setLightbox] = useState(false);
  /** Режим смены имени (по клику на имя — единственное редактируемое поле
      профиля; фото меняется своей строкой). */
  const [editingName, setEditingName] = useState(false);
  /** Счётчик перевыбора аватара: после upload перечитываем профиль. */
  const [avatarTick, setAvatarTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    fetchOwnProfile(client)
      .then((p) => {
        if (!cancelled) setProfile(p);
      })
      .catch((e) => {
        if (!cancelled) setError(humanError(e));
      });
    return () => {
      cancelled = true;
    };
  }, [client, avatarTick]);

  // ESC ЗАКРЫВАЕТ КАБИНЕТ (BUG-2, задача Антона 2026-09-13: «из кабинета
  // всегда есть выход: кнопка + Esc»). До этой правки Esc обрабатывали
  // только лайтбоксы внутри кабинета, а сам экран — нет: человек нажимал
  // Esc, ничего не происходило, и это читалось как «подвисание».
  //
  // Условие НЕ срабатывания: открыт лайтбокс (аватар/медиа) или редактор
  // имени — у них свой Esc (закрыть лайтбокс / отменить ввод), и двойное
  // закрытие по одной клавише путало бы. Проверяем по состоянию, а не по
  // event.target: клавиатурный фокус может быть на любом элементе.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      if (lightbox || editingName) return; // у этих состояний свой Esc
      // Редактор имени устройства и редактор внутри раздела файлов тоже
      // имеют свой Esc: не перехватываем, если фокус в input/textarea.
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
      onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, lightbox, editingName]);

  // Аватар — через авторизованный blob (наш Synapse отдаёт media только
  // с Bearer, см. matrix/media.ts). Голый <img src=http> дал бы 401.
  const mxc = profile?.avatarMxc ?? null;
  const { url: avatarUrl } = useAuthedMedia(client, mxc);

  const displayName = profile?.displayName ?? null;
  const userId = profile?.userId ?? client.getUserId() ?? "";
  const nameShown = displayName ?? userId;
  const initials = (() => {
    const clean = nameShown.replace(/^@/, "");
    const words = clean.split(/[\s_\-.:]+/).filter(Boolean);
    if (words.length === 0) return "?";
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
  })();

  return (
    <section style={st.main} data-testid="profile-view" aria-label={t("profile.title")}>
      {/* Шапка экрана: крестик закрытия. Назад — закрытие кабинета
          целиком; раскрытый раздел закрывается своей строкой-заголовком. */}
      <header style={st.topRow}>
        <h2 style={st.title}>{t("profile.title")}</h2>
        <div style={{ flex: "1 1 auto" }} />
        <button
          type="button"
          style={st.iconBtn}
          onClick={onClose}
          title={t("common.close")}
          aria-label={t("profile.closeCabinet")}
          data-testid="profile-close"
        >
          <IconClose size={18} />
        </button>
      </header>

      <div style={st.scroll}>
        {error && (
          <div style={st.errorBar} role="alert" data-testid="profile-error">
            {error}
          </div>
        )}

        {/* ДЕСКТОПНАЯ ШАПКА ПРОФИЛЯ: кружок 112px СЛЕВА, имя и MXID
            СПРАВА от кружка (постановка п.1 — НЕ поверх фото, никакой
            растянутой телеграм-шапки). */}
        <div style={st.header}>
          <AvatarCircle
            avatarUrl={avatarUrl}
            initials={initials}
            seed={userId}
            onOpen={() => {
              // Лайтбокс только когда есть что показывать: по заглушке с
              // инициалами кликать незачем — увеличивать буквы бессмысленно.
              if (avatarUrl) setLightbox(true);
            }}
            clickable={Boolean(avatarUrl)}
          />
          <div style={{ flex: "1 1 auto", minWidth: 0 }}>
            {editingName ? (
              <NameEditor
                current={displayName ?? ""}
                onCancel={() => setEditingName(false)}
                onSave={async (name) => {
                  await setOwnDisplayName(client, name);
                  setEditingName(false);
                  setAvatarTick((t) => t + 1); // перечитать профиль
                }}
              />
            ) : (
              <button
                type="button"
                style={st.nameBtn}
                onClick={() => setEditingName(true)}
                title={t("profile.clickToRename")}
                data-testid="profile-name"
              >
                <span style={st.nameText}>{nameShown}</span>
              </button>
            )}
            <div style={st.mxid} data-testid="profile-mxid">
              {userId}
            </div>
          </div>
        </div>

        {/* «Изменить фото» — ОТДЕЛЬНАЯ АКЦЕНТНАЯ СТРОКА (постановка п.3),
            не пункт в списке разделов. */}
        <ChangePhotoRow
          client={client}
          onDone={() => setAvatarTick((t) => t + 1)}
        />

        {/* ПЯТЬ РАЗДЕЛОВ. Список закрыт постановкой — новых не добавлять. */}
        <div style={st.cards}>
          <SectionCard
            testId="profile-section-devices"
            icon={<IconDevices size={20} />}
            label={t("profile.devices")}
            open={section === "devices"}
            onToggle={() => setSection(section === "devices" ? null : "devices")}
          >
            <DevicesSection client={client} onLogout={onLogout} />
          </SectionCard>

          <SectionCard
            testId="profile-section-myfiles"
            icon={<IconImage size={20} />}
            label={t("profile.files")}
            open={section === "myFiles"}
            onToggle={() => setSection(section === "myFiles" ? null : "myFiles")}
          >
            <FilesSection client={client} mine />
          </SectionCard>

          <SectionCard
            testId="profile-section-shared"
            icon={<IconUsers size={20} />}
            label={t("profile.sharedFiles")}
            open={section === "sharedFiles"}
            onToggle={() => setSection(section === "sharedFiles" ? null : "sharedFiles")}
          >
            <FilesSection client={client} mine={false} />
          </SectionCard>

          <SectionCard
            testId="profile-section-notifications"
            icon={<IconBell size={20} />}
            label={t("profile.notifications")}
            open={section === "notifications"}
            onToggle={() =>
              setSection(section === "notifications" ? null : "notifications")
            }
          >
            <NotificationsSection permission={notifPermission} />
          </SectionCard>

          <SectionCard
            testId="profile-section-language"
            icon={<IconGlobe size={20} />}
            label={t("profile.language")}
            open={section === "language"}
            onToggle={() => setSection(section === "language" ? null : "language")}
          >
            <LanguageSection />
          </SectionCard>

          <SectionCard
            testId="profile-section-appearance"
            icon={<IconPalette size={20} />}
            label={t("profile.appearance")}
            open={section === "appearance"}
            onToggle={() => setSection(section === "appearance" ? null : "appearance")}
          >
            <AppearanceSection />
          </SectionCard>
        </div>

        {/* СЕРВЕР — перед выходом. Показываем, к чему подключены,
            и даём сменить. Смена сервера НЕ выход: сессия этого сервера
            сохраняется, и возврат пройдёт без повторного логина. */}
        {serverName && onSwitchServer && (
          <button type="button" style={st.serverRow} onClick={onSwitchServer} data-testid="profile-switch-server">
            <span>
              {t("profile.server")}: <strong>{serverName}</strong>
              {serverUrl && (
                <small style={st.serverRowHost}>{serverUrl.replace(/^https:\/\//, "")}</small>
              )}
            </span>
            <span style={st.serverRowAction}>{t("profile.serverChange")}</span>
          </button>
        )}

        {/* ВЫЙТИ — ПОСЛЕДНЯЯ СТРОКА, ПОСЛЕ ВСЕХ ПЯТИ РАЗДЕЛОВ (правка
            Антона 12.09 12:26 п.2). Красным, с подтверждением. Это
            действие, а НЕ шестой раздел: карточкой не оформляется. */}
        <LogoutRow onLogout={onLogout} />
      </div>

      {lightbox && avatarUrl && (
        <AvatarLightbox url={avatarUrl} name={nameShown} onClose={() => setLightbox(false)} />
      )}
    </section>
  );
}

/* ------------------------------------------------------------------------
 * Шапка профиля
 * --------------------------------------------------------------------- */

function AvatarCircle({
  avatarUrl,
  initials,
  seed,
  onOpen,
  clickable,
}: {
  avatarUrl: string | null;
  initials: string;
  /** Детерминированный цвет заглушки — та же colorOf, что в списке чатов. */
  seed: string;
  onOpen: () => void;
  clickable: boolean;
}) {
  const t = useT();
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [avatarUrl]);

  const inner =
    avatarUrl && !broken ? (
      <img
        src={avatarUrl}
        alt=""
        style={st.avatarImg}
        onError={() => setBroken(true)}
        data-testid="profile-avatar-img"
      />
    ) : (
      <div
        style={{ ...st.avatarStub, background: colorOf(seed || "?") }}
        aria-hidden
        data-testid="profile-avatar-stub"
      >
        {initials}
      </div>
    );

  return (
    <button
      type="button"
      style={{
        ...st.avatarBtn,
        cursor: clickable ? "zoom-in" : "default",
      }}
      onClick={onOpen}
      disabled={!clickable}
      title={clickable ? t("profile.openPhoto") : t("profile.photoNotSet")}
      aria-label={t("profile.photo")}
      data-testid="profile-avatar"
    >
      {inner}
    </button>
  );
}

/**
 * Лайтбокс аватара во весь экран (клик по кружку, постановка п.1).
 *
 * Свой минимальный, а НЕ MediaViewer: там карусель по вложениям комнаты
 * со скачиванием/шерингом — здесь слайд один, и контролы MediaViewer
 * были бы мёртвыми кнопками. Закрытие: клик по фону, крестик, Esc —
 * тот же набор, что у MediaViewer, чтобы жесты не различались.
 */
function AvatarLightbox({
  url,
  name,
  onClose,
}: {
  url: string;
  name: string;
  onClose: () => void;
}) {
  const t = useT();
  const tfmt = useTF();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      style={st.lightboxBackdrop}
      onClick={onClose}
      role="dialog"
      aria-label={tfmt("profile.photoOf", { name })}
      data-testid="profile-avatar-lightbox"
    >
      <button
        type="button"
        style={st.lightboxClose}
        onClick={onClose}
        title={t("ui.zakryt_esc")}
        aria-label={t("common.close")}
        data-testid="profile-lightbox-close"
      >
        <IconClose size={22} />
      </button>
      {/* Клик по самому фото закрывать НЕ должен — только по фону.
          Зум — общий Zoomable: тот же механизм, что в MediaViewer, чтобы
          жесты не различались (постановка Антона 2026-10-05). */}
      <Zoomable>
        <img
          src={url}
          alt={name}
          style={st.lightboxImg}
          draggable={false}
          onClick={(e) => e.stopPropagation()}
        />
      </Zoomable>
    </div>
  );
}

/**
 * Редактор имени. Пустое имя не сохраняем: setDisplayName("") сбрасывает
 * имя в MXID, и человек получил бы «имя пропало» вместо «имя пустое».
 * Кнопка сохранения гаснет на пустом/без изменений — явно, а не ошибкой.
 */
function NameEditor({
  current,
  onCancel,
  onSave,
}: {
  current: string;
  onCancel: () => void;
  onSave: (name: string) => Promise<void>;
}) {
  const t = useT();
  const [value, setValue] = useState(current);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const trimmed = value.trim();
  const canSave = trimmed.length > 0 && trimmed !== current && !busy;

  const save = async () => {
    if (!canSave) return;
    setBusy(true);
    setErr(null);
    try {
      await onSave(trimmed);
    } catch (e) {
      setErr(humanError(e));
      setBusy(false);
    }
  };

  return (
    <div data-testid="profile-name-editor">
      <div style={{ display: "flex", gap: space.sm, alignItems: "center" }}>
        <input
          ref={inputRef}
          style={st.nameInput}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") void save();
            if (e.key === "Escape") onCancel();
          }}
          maxLength={100}
          aria-label={t("profile.displayName")}
          data-testid="profile-name-input"
        />
        <button
          type="button"
          style={{ ...st.smallBtn, opacity: canSave ? 1 : 0.45 }}
          disabled={!canSave}
          onClick={() => void save()}
          title={t("common.save")}
          data-testid="profile-name-save"
        >
          <IconCheck size={16} />
        </button>
        <button
          type="button"
          style={st.smallBtnGhost}
          onClick={onCancel}
          disabled={busy}
          title={t("common.cancel")}
          data-testid="profile-name-cancel"
        >
          <IconClose size={16} />
        </button>
      </div>
      {busy && <div style={st.hint}>{t("profile.saving")}</div>}
      {err && (
        <div style={st.errorText} role="alert">
          {err}
        </div>
      )}
    </div>
  );
}

/**
 * «Изменить фото» — отдельная акцентная строка (постановка п.3).
 *
 * Скрытый input[type=file] + явная кнопка: drag-and-drop на аватар не
 * делаем (жест неочевиден, а строка и так однозначна). Принимаем только
 * image/* — аватар-не-картинка сервер примет, а показать его мы не
 * сможем, и человек получил бы пустой кружок вместо фото.
 */
function ChangePhotoRow({
  client,
  onDone,
}: {
  client: MatrixClient;
  onDone: () => void;
}) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  // busy держим в ref: он читается внутри обработчика, и замыкание на
  // старое значение состояния дало бы ложное «свободно».
  const busyRef = useRef(false);

  const onFile = async (file: File) => {
    // Сдерживаем именно ОТПРАВКУ, а не выбор файла: две параллельные
    // загрузки аватара бессмысленны, а запрет выбора делает кнопку мёртвой.
    if (busyRef.current) throw new Error(t("picker.busy"));
    busyRef.current = true;
    setBusy(true);
    try {
      await setOwnAvatar(client, file);
      onDone();
    } catch (e) {
      // Текст ошибки покажет строка диагностики под кнопкой — одно место
      // вместо двух одинаковых надписей подряд.
      throw new Error(humanError(e));
    } finally {
      // Сброс ВСЕГДА, включая ветки ошибок и исключений.
      busyRef.current = false;
      setBusy(false);
    }
  };

  // Единый механизм выбора файла (см. useImagePicker): сброс value, проверка
  // типа и видимая человеку диагностика живут внутри хука.
  const picker = useImagePicker({ onFile });

  return (
    <div style={{ marginBottom: space.xl }}>
      <input
        ref={picker.ref}
        id={picker.id}
        type="file"
        accept={AVATAR_ACCEPT}
        style={visuallyHiddenInput}
        tabIndex={-1}
        aria-hidden="true"
        data-testid="profile-photo-input"
        onChange={picker.onChange}
      />
      {/* disabled={busy} УБРАН (Антон 24.09, второй заход). Заблокированная
          кнопка не даёт ни клика, ни диалога, молча — это дословно жалоба
          «вижу, но не нажимается». А busy залипал навсегда при зависшем
          uploadContent (таймаута у него нет). Выбрать файл можно всегда;
          повторную ОТПРАВКУ сдерживает busy внутри onFile. */}
      <button
        type="button"
        style={st.photoRow}
        onClick={picker.open}
        data-testid="profile-change-photo"
      >
        <span style={st.photoRowIcon}>
          <IconCamera size={20} />
        </span>
        <span style={st.photoRowLabel}>
          {busy ? t("profile.uploadPhoto") : t("profile.changePhoto")}
        </span>
      </button>
      {/* Видимая диагностика: что произошло после нажатия. Консоль Антону
          недоступна, поэтому это единственный способ отличить мёртвую
          кнопку от отказа системы открыть диалог. */}
      <PickerNoteLine note={picker.note} testId="profile-photo-note" />
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Карточки разделов
 * --------------------------------------------------------------------- */

/**
 * Карточка раздела: иконка слева, название, ТЕКУЩЕЕ ЗНАЧЕНИЕ справа
 * серым (постановка п.3), шеврон. Тело раскрывается под заголовком —
 * как в Telegram Desktop, где разделы настроек раскрываются на месте,
 * а не уводят на новый экран (и не ломают список из пяти).
 */
function SectionCard({
  testId,
  icon,
  label,
  value,
  open,
  onToggle,
  children,
}: {
  testId: string;
  icon: ReactNode;
  label: string;
  /** Текущее значение справа серым; нет — не показываем. */
  value?: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <div style={st.card} data-testid={testId}>
      <button
        type="button"
        style={st.cardHead}
        onClick={onToggle}
        aria-expanded={open}
        data-testid={testId + "-toggle"}
      >
        <span style={st.cardIcon} aria-hidden>
          {icon}
        </span>
        <span style={st.cardLabel}>{label}</span>
        {value && (
          <span style={st.cardValue} data-testid={testId + "-value"}>
            {value}
          </span>
        )}
        <span
          style={{
            ...st.cardChevron,
            transform: open ? "rotate(90deg)" : "none",
          }}
          aria-hidden
        >
          <IconChevronRight size={16} />
        </span>
      </button>
      {open && <div style={st.cardBody}>{children}</div>}
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Раздел «Устройства»
 *
 * ПЕРЕДЕЛАНО ЦЕЛИКОМ (задача Антона 2026-09-12 17:52, поправка 17:58;
 * ДОРАБОТКА 18:40; ГРУППИРОВКА — 18:50 приѐмка Момо).
 *
 * УСТРОЙСТВО = связка «машина + клиент» (требование Антона). Одно
 * физическое устройство может быть представлено В /devices НЕСКОЛЬКИМИ
 * device_id: очистка localStorage, гостевой профиль браузера, повторный
 * вход с новым device_id. Поэтому сверху сворачиваем их в ОДНУ группу
 * (groupDevices в profile.ts), сессии (отдельные device_id) — внутри по
 * клику. Признак склейки — display_name: единственное поле, которое
 * Synapse реально отдаёт (user_agent и тип клиента /devices НЕ
 * возвращает — замер по IMyDevice в matrix-js-sdk).
 *
 * ОГРАНИЧЕНИЕ СКЛЕЙКИ (честно): два разных устройства с одинаковым
 * display_name склеются в одну группу — ложное слияние, распознать
 * которое без user_agent нельзя. Безымянные записи не склеиваем.
 *
 * ЧТО ЗДЕСЬ ЕСТЬ:
 *  - одна группа верхнего уровня = одна связка «машина + клиент»,
 *    внутри — сессии (device_id) с активностью/IP/переименованием/удалением;
 *  - человеческое имя («Mac · Chrome (веб)» — по UA ЭТОГО браузера для
 *    текущего, чужие записи не угадываем);
 *  - дата добавления (только у текущего — из нашего первого запуска),
 *    последняя активность и IP — требования Антона;
 *  - переименование (PUT /devices/{id}, UIA не требует);
 *  - видимое оповещение о новых устройствах (снимок «увиденных» в
 *    localStorage; честно: при открытии раздела, не push);
 *  - удаление — внутри приложения: Matrix DELETE /_matrix/client/v3/devices/{id}
 *    для каждого device_id группы (C-S API, при необходимости фолбэк
 *    в MAS GraphQL — см. deleteDevice в matrix/profile.ts). Кнопка видна у
 *    КАЖДОГО устройства, включая текущее (для текущего — честное
 *    подтверждение «это выход из аккаунта»);
 *  - лимит устройств: одна настройка (config.deviceLimit), но
 *    серверной части пока НЕТ — интерфейс честно говорит, что
 *    ограничение ещё не действует.
 * --------------------------------------------------------------------- */

/**
 * СЕССИИ В КАБИНЕТЕ НЕ ПОКАЗЫВАЮТСЯ ВООБЩЕ (Антон 24.09 19:45
 * «Список сессий показывать не надо» + 25.09 15:04 «в кабинете спрятать
 * сессии, оставить только устройства»).
 *
 * БЫЛО ДО ЭТОЙ ПРАВКИ и ПОЧЕМУ НЕ СРАБОТАЛО: с 13.09 сессии были
 * спрятаны УСЛОВНО — за отладочным флагом localStorage
 * "alg.devices.admin" (adminMode). Флаг выставлялся руками в консоли
 * браузера и ОСТАВАЛСЯ там навсегда: у того, кто когда-то включил
 * его для отладки, сессии продолжали показываться, и никакая выкладка
 * этого не меняла. Именно поэтому требование пришлось повторять дважды.
 *
 * СТАЛО: сессий в интерфейсе НЕТ БЕЗУСЛОВНО. Флаг удалён целиком,
 * включить показ из браузера больше нельзя — у Антона старое значение
 * в localStorage перестанет действовать само собой, без чистки браузера.
 * С экрана уходят три вещи, все про одну и ту же сущность:
 *   1) раскрывающийся список сессий внутри карточки устройства;
 *   2) счётчик «· N сессий» в шапке карточки;
 *   3) подсказка profile.multipleSessionsHint «несколько входов…».
 * Заодно уходит IP в подписи — это тоже атрибут сессии, а не устройства.
 *
 * ЧТО ОСТАЛОСЬ НА ЭКРАНЕ: список УСТРОЙСТВ (группы groupDevices
 * по display_name), имя, время последней активности, пометка «это
 * устройство» и удаление устройства целиком.
 *
 * КОД СЕССИЙ НЕ УДАЛЁН (Антон: «спрятать», а не «вырезать») — см.
 * комментарий над SessionRow ниже.
 */

function DevicesSection({
  client,
  onLogout,
}: {
  client: MatrixClient;
  onLogout: () => void | Promise<void>;
}) {
  const t = useT();
  const tfmt = useTF();
  const [devices, setDevices] = useState<DeviceInfo[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  /** Перезагрузка после переименования/удаления. */
  const [tick, setTick] = useState(0);
  /** Новые устройства с прошлого просмотра (видимое оповещение). */
  const [fresh, setFresh] = useState<DeviceInfo[]>([]);
  /** Экран «Добавить устройство» (Device Code Flow). */
  const [addDeviceOpen, setAddDeviceOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchOwnDevices(client)
      .then((d) => {
        if (cancelled) return;
        setDevices(d);
        // Оповещение считаем ДО фиксации снимка: раздел открыт — человек
        // увидит и список, и баннер; дальше всё увиденное перестаёт быть новым.
        const { fresh } = diffNewDevices(d);
        setFresh(fresh);
        markDevicesSeen(d);
      })
      .catch((e) => {
        if (!cancelled) setErr(humanError(e));
      });
    return () => {
      cancelled = true;
    };
  }, [client, tick]);

  if (err) {
    return (
      <div style={st.errorText} role="alert" data-testid="profile-devices-error">
        {err}
      </div>
    );
  }
  if (!devices) return <div style={st.hint}>{t("profile.loadingDevices")}</div>;

  const currentId = client.getDeviceId() ?? null;
  // Группы «машина + клиент»: несколько device_id одного физического
  // устройства сворачиваются в ОДНУ запись верхнего уровня (Антон:
  // «должна быть 1 запись»). Сессии внутри — по клику.
  const groups = groupDevices(devices);
  return (
    <div data-testid="profile-devices">
      {/* ВИДИМОЕ ОПОВЕЩЕНИЕ О НОВОМ УСТРОЙСТВЕ (требование Антона).
          Честный механизм: снимок «увиденных» при прошлом открытии
          раздела, поэтому баннер появляется при заходе в кабинет,
          а не пушем в реальном времени. */}
      {fresh.length > 0 && (
        <div style={st.newDeviceBanner} role="alert" data-testid="profile-devices-new">
          {tfmt(fresh.length === 1 ? "profile.newDeviceOne" : "profile.newDeviceMany", {
            count: fresh.length,
            devices: fresh.map((d) => d.displayName ?? t("ui.bez_imeni")).join(", "),
          })}{t("profile.notYouHint")}</div>
      )}

      {/* СЧЁТЧИК: считаем ГРУППЫ (машина+клиент), а не сырой device_id —
          иначе три повторных входа с одной машины выглядели бы как три
          «устройства» (та самая претензия Антона). */}
      <div style={{ ...st.hint, marginBottom: space.md }} data-testid="profile-devices-count">
        {tfmt("profile.deviceCount", { count: groups.length, limit: config.deviceLimit })}
        {groups.length >= config.deviceLimit
          ? t("ui.limit_poka_ne_deystvuet_servernaya_chast")
          : ""}
      </div>
      {groups.map((g) => (
        // КЛЮЧ — `device_id`, А НЕ ИМЯ. После отказа от склейки по
        // display_name (25.09) два устройства с одинаковым именем —
        // нормальное состояние, а не исключение. Имя в качестве ключа
        // дало бы дубликаты, а React при дублирующихся ключах
        // переиспользует чужой узел — после удаления одного устройства
        // соседняя строка показывала бы его данные.
        <DeviceCard
          key={g.devices[0]?.deviceId ?? `orphan-${g.displayName ?? "?"}`}
          client={client}
          group={g}
          currentId={currentId}
          onDeleted={() => setTick((t) => t + 1)}
          onLogout={onLogout}
        />
      ))}

      {/* ДОБАВИТЬ УСТРОЙСТВО — свой экран входа по коду (Device Code
          Flow, RFC 8628). Сервер поддерживает (замер 2026-09-12:
          device_authorization_endpoint живой, grant объявлен).
          Код генерируется ЗДЕСЬ, вводится на новом устройстве. */}
      <button
        type="button"
        style={st.deviceAddBtn}
        onClick={() => setAddDeviceOpen(true)}
        data-testid="profile-devices-add"
      >{t("profile.addDevice")}</button>
      <div style={{ ...st.hint, marginTop: space.sm }} data-testid="profile-devices-add-hint">{t("profile.deviceCodeHint")}</div>

      {/* ЛИМИТ УСТРОЙСТВ (Антон 18:22: «5 устройств, дальше запрос
          на подтверждение админа»). Серверной части пока НЕТ (её делает
          Момо) — поэтому честная плашка о будущем ограничении, а не
          проверка, которая ничего не проверяет. */}
      <div style={{ ...st.hint, marginTop: space.lg }} data-testid="profile-devices-limit">
        {t("profile.deviceLimitHead")} {config.deviceLimit + 1}
        {t("profile.deviceLimitHint")}
      </div>

      {/* ЭКРАН «ДОБАВИТЬ УСТРОЙСТВО» — генератор кода для нового
          устройства. Открывается поверх раздела. */}
      {addDeviceOpen && (
        <AddDeviceScreen onClose={() => setAddDeviceOpen(false)} />
      )}
    </div>
  );
}

/**
 * Карточка ГРУППЫ «машина + клиент» (верхний уровень раздела).
 *
 * Сворачивает несколько device_id одного физического устройства в ОДНУ
 * запись. Удаление — КАЖДОЙ группы, включая текущую: кнопка удаления
 * видна ВСЕМ пользователям (не только админу), потому что удаление —
 * это действие уровня «устройство», а не технической сессии.
 *
 * ИМЯ группы (требование Антона «MacBook · Safari»):
 *  - если в группе текущее устройство — его человеческое имя по UA ЭТОГО
 *    браузера («Mac · Chrome (веб)», если сам group.displayName пуст);
 *  - иначе — display_name от сервера, либо «Устройство без имени».
 *  Пометка «· это устройство» ставится, если в группе есть наш deviceId.
 *
 * УДАЛЕНИЕ: Matrix DELETE /_matrix/client/v3/devices/{deviceId} для
 * каждого device_id группы. Для текущего устройства — отдельное честное
 * подтверждение «это выход из аккаунта», после удаления вызывается
 * onLogout (App перезагрузит клиент на экран входа). Для чужих — обычное
 * подтверждение в 1-2 клика.
 */
function DeviceCard({
  client,
  group,
  currentId,
  onDeleted,
  onLogout,
}: {
  client: MatrixClient;
  group: DeviceGroup;
  currentId: string | null;
  /* onRenamed убран вместе с переименованием сессий: его единственным
     потребителем был SessionRow, который больше не рисуется. Передавать
     коллбэк «на всякий случай» нельзя — tsc с noUnusedParameters отказывает. */
  /** Перезагрузка списка после удаления устройства. */
  onDeleted: () => void;
  /** Выход из аккаунта — вызывается после удаления ТЕКУЩЕЙ группы. */
  onLogout: () => void | Promise<void>;
}) {
  const t = useT();
  const tfmt = useTF();
  const current = group.devices.find((d) => d.deviceId === currentId);
  const isCurrentGroup = Boolean(current);

  // Удаление всей группы (всех device_id внутри).
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);

  const nameShown = current
    ? (current.displayName ?? currentDeviceLabel())
    : (group.displayName ?? t("ui.ustroystvo_bez_imeni"));

  const latestTs = group.devices.reduce((max, d) => Math.max(max, d.lastSeenTs ?? 0), 0);

  const doDelete = async () => {
    setDeleting(true);
    setDeleteError(null);
    try {
      // Удаляем ВСЕ device_id группы. Текущий device_id удаляем ПОСЛЕДНИМ:
      // его удаление очищает localStorage (сессия мертва), и после этого
      // оставшиеся вызовы SDK всё равно прошли бы, но чище завершить группу
      // целиком до выхода. Чужие device_id удаляем первыми.
      const sorted = [...group.devices].sort((a, b) => {
        const ai = a.deviceId === currentId ? 1 : 0;
        const bi = b.deviceId === currentId ? 1 : 0;
        return ai - bi;
      });
      for (const d of sorted) {
        await deleteDevice(client, d.deviceId);
      }
      if (isCurrentGroup) {
        onLogout();
      } else {
        onDeleted();
      }
    } catch (e) {
      setDeleteError(humanError(e));
      setDeleting(false);
      setConfirmDelete(false);
    }
  };

  return (
    <div style={st.deviceCard} data-testid="profile-device-card">
      {/* Шапка НЕ кликабельна: раскрывать внутри больше нечего (сессии
          убраны с экрана), поэтому рисуем div, а не button — иначе
          показали бы интерактивный элемент, который ничего не делает
          (хуже отсутствующей кнопки). Справа — кнопка удаления
          (уровень «устройство»). */}
      <div style={{ display: "flex", alignItems: "center", gap: space.sm }}>
        <div style={{ flex: "1 1 auto", minWidth: 0, display: "flex", alignItems: "center" }}>
          <div style={{ ...st.deviceRow, flex: "1 1 auto" }} data-testid="profile-device-header">
            <DeviceHeaderContent
              nameShown={nameShown}
              current={current}
              latestTs={latestTs}
            />
          </div>
        </div>
        <button
          type="button"
          style={st.deviceDeleteBtn}
          onClick={() => {
            setConfirmDelete(true);
            setDeleteError(null);
          }}
          title={
            isCurrentGroup
              ? t("ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta")
              : t("ui.udalit_eto_ustroystvo")
          }
          aria-label={
            isCurrentGroup
              ? t("ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta")
              : t("ui.udalit_ustroystvo")
          }
          data-testid="profile-device-delete"
        >
          <IconTrash size={15} />
        </button>
      </div>

      {/* Подтверждение удаления ГРУППЫ — инлайн, под шапкой. Текущее
          устройство — danger-текст «это выход из аккаунта». */}
      {confirmDelete && (
        <div style={st.sessionRow} data-testid="profile-device-delete-confirm-row">
          <div style={{ flex: "1 1 auto", minWidth: 0 }}>
            <div
              style={{
                ...st.deviceMeta,
                color: isCurrentGroup ? color.danger : undefined,
                fontWeight: isCurrentGroup ? 700 : undefined,
              }}
            >
              {isCurrentGroup
                ? t("profile.deleteCurrentDeviceQuestion")
                : tfmt("profile.deleteDeviceQuestion", { device: nameShown })}
            </div>
            {deleteError && (
              <div style={{ ...st.errorText, marginTop: space.sm }} role="alert">
                {deleteError}
              </div>
            )}
          </div>
          <button
            type="button"
            style={st.logoutYes}
            onClick={() => void doDelete()}
            disabled={deleting}
            data-testid="profile-device-delete-confirm"
          >
            {deleting ? t("ui.udalyayu") : t("common.yesDelete")}
          </button>
          <button
            type="button"
            style={st.logoutNo}
            onClick={() => setConfirmDelete(false)}
            disabled={deleting}
            data-testid="profile-device-delete-cancel"
          >{t("common.cancel")}</button>
        </div>
      )}

      {/* СЕССИЙ ЗДЕСЬ БОЛЬШЕ НЕТ — ни списка, ни скрытого блока в DOM,
          ни подсказки profile.multipleSessionsHint (Антон 24.09/25.09).
          Компонент SessionRow сохранён ниже, но отсюда не вызывается. */}
    </div>
  );
}

/**
 * Содержимое шапки карточки устройства.
 *
 * Только атрибуты УСТРОЙСТВА: имя, пометка «это устройство» и время
 * последней активности. Счётчика «· N сессий» и IP больше нет: и то,
 * и другое — атрибуты СЕССИИ, а сессии с экрана убраны целиком.
 * Поэтому же ушёл проп group: он нужен был только ради devices.length
 * и lastSeenIp первой сессии.
 */
function DeviceHeaderContent({
  nameShown,
  current,
  latestTs,
}: {
  nameShown: string;
  current: DeviceInfo | undefined;
  latestTs: number;
}) {
  const t = useT();
  const tfmt = useTF();
  const locale = useLocale();
  return (
    <>
      <span style={st.deviceIcon} aria-hidden>
        <IconDevices size={16} />
      </span>
      <div style={{ flex: "1 1 auto", minWidth: 0 }}>
        <div style={st.deviceName}>
          {nameShown}
          {current && <span style={st.deviceCurrent}>{t("profile.thisDeviceSuffix")}</span>}
        </div>
        <div style={st.deviceMeta} data-testid="profile-device-meta">
          {latestTs
            ? tfmt("profile.deviceActive", {
                date: new Date(latestTs).toLocaleString(locale),
              })
            : t("profile.devicesUnknownActivity")}
        </div>
      </div>
    </>
  );
}

/**
 * Одна сессия (device_id) внутри группы — с переименованием и удалением.
 * Удаление доступно для каждой сессии, включая текущую (для текущей —
 * честное подтверждение «это выход из аккаунта»).
 *
 * ╔═══════════════════════════════════════════════════════════════════╗
 * ║ С ЭКРАНА УБРАНО, НО НАМЕРЕННО ОСТАВЛЕНО В КОДЕ.                  ║
 * ║ Антон 25.09 15:04 просил именно «спрятать», а НЕ «вырезать».        ║
 * ║ SessionRow больше не вызывается из UI; DeviceNameEditor жив только   ║
 * ║ через него. НЕ УДАЛЯТЬ «за ненадобностью»: админский экран       ║
 * ║ сессий — ожидаемое продолжение, тогда компонент нужен целиком.  ║
 * ║                                                                       ║
 * ║ ПОЧЕМУ export У НЕИСПОЛЬЗУЕМОГО КОМПОНЕНТА — ЗАМЕР, НЕ ВКУС:     ║
 * ║ без export сборка ПАДАЕТ — tsc с noUnusedLocals (tsconfig.json)      ║
 * ║ даёт TS6133 «'SessionRow' is declared but its value is never read».    ║
 * ║ Это проверено запуском, а не предположением: первая версия      ║
 * ║ этой правки именно так и упала. export — способ сохранить код    ║
 * ║ без подавления проверки (@ts-ignore / eslint-disable скрыли бы      ║
 * ║ и будущие ошибки в этом месте). На размер бандла не влияет:    ║
 * ║ vite/rollup вырезает его tree-shaking'ом — из точки входа           ║
 * ║ ссылок на него нет.                                               ║
 * ╚═══════════════════════════════════════════════════════════════════╝
 */
export function SessionRow({
  client,
  device,
  isCurrent,
  onRenamed,
  onDeleted,
}: {
  client: MatrixClient;
  device: DeviceInfo;
  isCurrent: boolean;
  onRenamed: () => void;
  /** Перезагрузка списка после удаления. */
  onDeleted: () => void;
}) {
  const t = useT();
  const tfmt = useTF();
  const locale = useLocale();
  const [editing, setEditing] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);

  if (editing) {
    return (
      <DeviceNameEditor
        client={client}
        device={device}
        onCancel={() => setEditing(false)}
        onSaved={() => {
          setEditing(false);
          onRenamed();
        }}
      />
    );
  }

  const doDelete = async () => {
    setDeleting(true);
    setDeleteError(null);
    try {
      await deleteDevice(client, device.deviceId);
      onDeleted();
    } catch (e) {
      setDeleteError(humanError(e));
      setDeleting(false);
      setConfirmDelete(false);
    }
  };

  // Текущее устройство: честное подтверждение, что это выход из аккаунта.
  if (isCurrent && confirmDelete) {
    return (
      <div style={st.sessionRow} data-testid="profile-device-session">
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <div style={{ ...st.deviceMeta, color: color.danger, fontWeight: 700 }}>{t("profile.deleteCurrentDeviceQuestion")}</div>
          {deleteError && (
            <div style={{ ...st.errorText, marginTop: space.sm }} role="alert">
              {deleteError}
            </div>
          )}
        </div>
        <button
          type="button"
          style={st.logoutYes}
          onClick={() => void doDelete()}
          disabled={deleting}
          data-testid="profile-device-delete-confirm"
        >
          {deleting ? t("ui.udalyayu") : t("common.yesDelete")}
        </button>
        <button
          type="button"
          style={st.logoutNo}
          onClick={() => setConfirmDelete(false)}
          disabled={deleting}
          data-testid="profile-device-delete-cancel"
        >{t("common.cancel")}</button>
      </div>
    );
  }

  // Обычное подтверждение для чужих устройств (1-2 клика).
  if (!isCurrent && confirmDelete) {
    return (
      <div style={st.sessionRow} data-testid="profile-device-session">
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <div style={st.deviceMeta}>
            {tfmt("profile.finishLoginQuestion", {
              device: device.displayName ?? t("ui.bez_imeni"),
            })}
          </div>
          {deleteError && (
            <div style={{ ...st.errorText, marginTop: space.sm }} role="alert">
              {deleteError}
            </div>
          )}
        </div>
        <button
          type="button"
          style={st.logoutYes}
          onClick={() => void doDelete()}
          disabled={deleting}
          data-testid="profile-device-delete-confirm"
        >
          {deleting ? t("ui.udalyayu") : t("ui.da_zavershit")}
        </button>
        <button
          type="button"
          style={st.logoutNo}
          onClick={() => setConfirmDelete(false)}
          disabled={deleting}
          data-testid="profile-device-delete-cancel"
        >{t("common.cancel")}</button>
      </div>
    );
  }

  return (
    <div style={st.sessionRow} data-testid="profile-device-session">
      <div style={{ flex: "1 1 auto", minWidth: 0 }}>
        <div style={st.deviceMeta} data-testid="profile-device-meta">
          {isCurrent && device.createdTs
            ? `${tfmt("profile.deviceAdded", {
                date: new Date(device.createdTs).toLocaleDateString(locale),
              })} · `
            : ""}
          {device.lastSeenTs
            ? tfmt("profile.deviceActive", {
                date: new Date(device.lastSeenTs).toLocaleString(locale),
              })
            : t("profile.devicesUnknownActivity")}
          {device.lastSeenIp ? ` · ${device.lastSeenIp}` : ""}
        </div>
        {!isCurrent && (
          <div style={st.deviceMeta}>{t("profile.clientUnknown")}</div>
        )}
      </div>
      <button
        type="button"
        style={st.deviceRenameBtn}
        onClick={() => setEditing(true)}
        title={t("profile.renameDevice")}
        aria-label={tfmt("profile.renameDeviceNamed", {
          device: device.displayName ?? t("ui.ustroystvo"),
        })}
        data-testid="profile-device-rename"
      >
        <IconEdit size={15} />
      </button>
      {/* Удаление: у КАЖДОГО устройства, включая текущее. Текущее — с
          честным подтверждением «это выход из аккаунта». */}
      <button
        type="button"
        style={st.deviceDeleteBtn}
        onClick={() => setConfirmDelete(true)}
        title={
          isCurrent
            ? t("ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta")
            : t("ui.zavershit_etot_vhod")
        }
        aria-label={
          isCurrent
            ? t("ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta")
            : tfmt("profile.endSessionNamed", {
                device: device.displayName ?? t("ui.bez_imeni"),
              })
        }
        data-testid="profile-device-delete"
      >
        <IconTrash size={15} />
      </button>
    </div>
  );
}

/**
 * Инлайн-редактор имени устройства — тот же паттерн, что у NameEditor
 * профиля: Enter/кнопка сохраняет, Esc отменяет, ошибка показывается
 * текстом рядом, а не глотается.
 *
 * Пустое имя = «Сбросить имя» (сервер трактует пустой display_name как
 * сброс). Это ОТДЕЛЬНАЯ кнопка, а не молчаливая интерпретация пустого
 * поля: случайно стёртое имя не должно улетать на сервер.
 */
function DeviceNameEditor({
  client,
  device,
  onCancel,
  onSaved,
}: {
  client: MatrixClient;
  device: DeviceInfo;
  onCancel: () => void;
  onSaved: () => void;
}) {
  const t = useT();
  const [value, setValue] = useState(device.displayName ?? "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const trimmed = value.trim();
  const unchanged = trimmed === (device.displayName ?? "");
  const canSave = trimmed.length > 0 && !unchanged && !busy;
  // «Сбросить» есть только у ИМЕНОВАННОГО устройства: у безымянного
  // сбрасывать нечего.
  const canReset = device.displayName !== null && !busy;

  const save = async (name: string) => {
    setBusy(true);
    setErr(null);
    try {
      await renameDevice(client, device.deviceId, name);
      onSaved();
    } catch (e) {
      setErr(humanError(e));
      setBusy(false);
    }
  };

  return (
    <div style={st.deviceCard} data-testid="profile-device-rename-editor">
      <div style={st.deviceRow}>
        <span style={st.deviceIcon} aria-hidden>
          <IconDevices size={16} />
        </span>
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <div style={{ display: "flex", gap: space.sm, alignItems: "center" }}>
            <input
              ref={inputRef}
              style={st.deviceNameInput}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && canSave) void save(trimmed);
                if (e.key === "Escape") onCancel();
              }}
              maxLength={100}
              placeholder={t("profile.deviceNamePlaceholder")}
              aria-label={t("profile.deviceNameLabel")}
              data-testid="profile-device-name-input"
            />
            <button
              type="button"
              style={{ ...st.smallBtn, opacity: canSave ? 1 : 0.45 }}
              disabled={!canSave}
              onClick={() => void save(trimmed)}
              title={t("common.save")}
              data-testid="profile-device-name-save"
            >
              <IconCheck size={16} />
            </button>
            <button
              type="button"
              style={st.smallBtnGhost}
              onClick={onCancel}
              disabled={busy}
              title={t("common.cancel")}
              data-testid="profile-device-name-cancel"
            >
              <IconClose size={16} />
            </button>
          </div>
          {canReset && (
            <button
              type="button"
              style={st.deviceResetBtn}
              onClick={() => void save("")}
              disabled={!canReset}
              data-testid="profile-device-name-reset"
            >{t("profile.resetDeviceName")}</button>
          )}
          {busy && <div style={st.hint}>{t("profile.saving")}</div>}
          {err && (
            <div style={st.errorText} role="alert">
              {err}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Экран «Добавить устройство» — Device Code Flow (RFC 8628).
 *
 * Генерирует код, который человек вводит на НОВОМ устройстве. Код
 * показывается КРУПНО, рядом — куда его ввести (verification_uri),
 * и счётчик срока жизни кода.
 *
 * ЧЕСТНОЕ ОГРАНИЧЕНИЕ: экран ГЕНЕРИРУЕТ и показывает код, но НЕ ждёт
 * подтверждения (не поллит token_endpoint). Полный цикл «код введён на
 * новом устройстве → список устройств обновился сам» не замкнут: новое
 * устройство завершает вход у себя (браузерный OIDC флоу через
 * verification_uri), а этот экран человек закрывает кнопкой «Готово» и
 * список перечитывается при следующем открытии раздела. Полный Device
 * Code Flow (waitForDeviceCode здесь + автообновление списка) — в profile.ts
 * уже есть поллинг (waitForDeviceCode), но он не подключён к этому экрану.
 * --------------------------------------------------------------------- */

function AddDeviceScreen({ onClose }: { onClose: () => void }) {
  const t = useT();
  const tfmt = useTF();
  const [session, setSession] = useState<DeviceCodeSession | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null);

  // Сгенерировать код при открытии экрана (Device Code Flow).
  const generate = () => {
    setError(null);
    setSession(null);
    setSecondsLeft(null);
    startDeviceCodeFlow()
      .then(setSession)
      .catch((e) => setError(humanError(e)));
  };

  useEffect(() => {
    generate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!session) return;
    const expiration = Date.now() + session.expiresIn * 1000;
    const update = () => {
      const left = Math.max(0, Math.floor((expiration - Date.now()) / 1000));
      setSecondsLeft(left);
    };
    update();
    const t = window.setInterval(update, 1000);
    return () => window.clearInterval(t);
  }, [session]);

  const formatTime = (s: number): string => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  return (
    <div style={st.lightboxBackdrop} data-testid="profile-add-device">
      <div
        style={{
          ...st.deviceCard,
          maxWidth: 480,
          width: "90%",
          padding: space.xl,
        }}
        role="dialog"
        aria-label={t("profile.addDevice")}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: space.lg }}>
          <h3 style={{ margin: 0, fontSize: font.body, fontWeight: font.weightBold }}>{t("profile.addDevice")}</h3>
          <button
            type="button"
            style={st.iconBtn}
            onClick={onClose}
            title={t("common.close")}
            aria-label={t("common.close")}
            data-testid="profile-add-device-close"
          >
            <IconClose size={18} />
          </button>
        </div>

        {error && (
          <div style={{ ...st.errorText, marginBottom: space.lg }} role="alert">
            {error}
          </div>
        )}

        {!session && !error && (
          <div style={st.hint}>{t("profile.generatingCode")}</div>
        )}

        {session && (
          <>
            <div style={{ marginBottom: space.lg }}>
              <div style={{ ...st.hint, marginBottom: space.sm }}>{t("profile.addDeviceCodeHint")}</div>
              <div
                style={{
                  fontSize: 32,
                  fontWeight: font.weightBold,
                  fontFamily: font.mono,
                  textAlign: "center",
                  padding: space.lg,
                  background: color.bg,
                  borderRadius: radius.md,
                  border: `1px solid ${color.border}`,
                  letterSpacing: 4,
                }}
                data-testid="profile-add-device-code"
              >
                {session.userCode}
              </div>
            </div>

            <div style={{ ...st.hint, marginBottom: space.md }}>{t("profile.openOnNewDevice")}<br />
              <a
                href={session.verificationUriComplete ?? session.verificationUri}
                target="_blank"
                rel="noreferrer noopener"
                style={{ color: color.accent, wordBreak: "break-all" }}
                data-testid="profile-add-device-link"
              >
                {session.verificationUriComplete ?? session.verificationUri}
              </a>
            </div>

            {secondsLeft !== null && (
              <div style={{ ...st.hint, marginBottom: space.md }} data-testid="profile-add-device-timer">
                {tfmt("profile.codeValid", { time: formatTime(secondsLeft) })}
              </div>
            )}

            <div style={{ display: "flex", gap: space.md }}>
              <button
                type="button"
                style={{ ...st.smallBtnGhost, flex: "1 1 auto", height: "auto", padding: `${space.md}px` }}
                onClick={generate}
                data-testid="profile-add-device-new-code"
              >{t("profile.newCode")}</button>
              <button
                type="button"
                style={{ ...st.smallBtn, flex: "1 1 auto", height: "auto", padding: `${space.md}px` }}
                onClick={onClose}
                data-testid="profile-add-device-done"
              >{t("common.done")}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Разделы файлов — ОДИН пункт «Файлы и медиа», внизу ДВА ТАБА
 * (уточнение Антона 2026-09-12 17:54, главнее первой формулировки):
 * «одним пунктом и то и другое, и внизу два табика: Files и Media».
 *
 * ВИД — из вкладок комнаты (src/ui/RoomTabs.tsx): ряд табов с подчёрком
 * по ширине слова, медиа — сетка 3×N квадратов с группировкой по месяцам,
 * файлы — список строк «иконка · имя · размер · дата». НЕ дропдаун и не
 * схлопывающийся список — это был баг №2 постановки.
 *
 * ПОИСК (Антон 18:00: «в моих файлах, фото должен быть поиск»): строка
 * над табами, фильтрует по мере ввода, без кнопки. Ищем по имени файла
 * И по подписи (filename/body — см. SharedFile), регистр не учитываем.
 * Поиск честно работает только по ЗАГРУЖЕННЫМ таймлайнам (серверного
 * индекса файлов у Synapse нет, README п.2) — об этом написано строкой
 * прямо в разделе, а не замаскировано.
 *
 * ПРЕВЬЮ: сетка берёт серверные /thumbnail (useAuthedThumb), НЕ оригиналы
 * — у Антона сотни файлов, страница легла бы. Клик по превью — лайтбокс
 * с полноразмерным просмотром (image/video через useAuthedMediaBlob).
 * --------------------------------------------------------------------- */

type FilesTabId = "media" | "files";

function FilesSection({ client, mine }: { client: MatrixClient; mine: boolean }) {
  const t = useT();
  // Сборка синхронная из памяти (таймлайны уже в клиенте) — useState с
  // ленивой инициализацией считает один раз на монтирование раздела.
  const [files] = useState<SharedFile[]>(() => collectFiles(client, mine));
  const [tab, setTab] = useState<FilesTabId>("media");
  const [query, setQuery] = useState("");
  /** Фильтр по комнате-источнику (Антон 18:00: «полезно и просто»). */
  const [roomFilter, setRoomFilter] = useState<string>("");
  /** Открытый в лайтбоксе слайд — eventId из сетки медиа. */
  const [viewer, setViewer] = useState<SharedFile | null>(null);

  const media = files.filter((f) => f.kind === "image" || f.kind === "video");
  const docs = files.filter((f) => f.kind !== "image" && f.kind !== "video");

  const rooms = Array.from(new Set(files.map((f) => f.roomName))).sort((a, b) =>
    a.localeCompare(b, "ru"),
  );

  const q = query.trim().toLowerCase();
  const matches = (f: SharedFile): boolean => {
    if (roomFilter && f.roomName !== roomFilter) return false;
    if (!q) return true;
    // Имя файла (filename, если есть, иначе body) И подпись/текст (body) —
    // оба поля проверяем, подстрока без регистра (Антон 18:00).
    if (f.name.toLowerCase().includes(q)) return true;
    if (f.filename && f.filename.toLowerCase().includes(q)) return true;
    return false;
  };
  const mediaShown = media.filter(matches);
  const docsShown = docs.filter(matches);
  const searching = q.length > 0 || roomFilter !== "";

  return (
    <div data-testid={mine ? "profile-my-files" : "profile-shared-files"}>
      {/* Честное ограничение источника — одной строкой, человеческим языком
          (требование постановки). Поиск ищет только по этому же объёму. */}
      <div style={{ ...st.hint, marginBottom: space.md }}>{t("profile.filesScopeHint")}</div>

      {/* ПОИСК: фильтрация по мере ввода, без кнопки «найти». */}
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={t("profile.filesSearchPlaceholder")}
        aria-label={t("profile.filesSearchAria")}
        style={st.searchInput}
        data-testid="profile-files-search"
      />
      {rooms.length > 1 && (
        <select
          value={roomFilter}
          onChange={(e) => setRoomFilter(e.target.value)}
          style={st.roomSelect}
          aria-label={t("ui.filtr_po_chatu")}
          data-testid="profile-files-room-filter"
        >
          <option value="">{t("profile.allChats")}</option>
          {rooms.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      )}

      {/* ДВА ТАБА: вид — как TabStrip в RoomTabs (ряд кнопок, активный
          таб — акцентный, подчёркнут ПО ШИРИНЕ СЛОВА 3px чертой). */}
      <div style={ft.strip} role="tablist">
        {(
          [
            { id: "media" as FilesTabId, label: t("profile.mediaTab") },
            { id: "files" as FilesTabId, label: t("profile.filesTab") },
          ]
        ).map((t) => {
          const on = t.id === tab;
          return (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => setTab(t.id)}
              data-testid={`profile-files-tab-${t.id}`}
              style={{
                ...ft.tabBtn,
                fontWeight: on ? 700 : 400,
                color: on ? color.accent : color.textMuted,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  paddingBottom: 5,
                  borderBottom: on
                    ? `3px solid ${color.accent}`
                    : "3px solid transparent",
                }}
              >
                {t.label}
              </span>
            </button>
          );
        })}
      </div>

      {tab === "media" ? (
        <MediaGrid
          client={client}
          items={mediaShown}
          searching={searching}
          onOpen={setViewer}
        />
      ) : (
        <FilesList client={client} items={docsShown} searching={searching} mine={mine} />
      )}

      {viewer && (
        <MediaLightbox client={client} file={viewer} onClose={() => setViewer(null)} />
      )}
    </div>
  );
}

/**
 * Таб «Медиа»: сетка 3×N квадратов, сгруппированная по месяцам — как
 * MediaTab в RoomTabs. Превью — серверные /thumbnail, не оригиналы.
 */
function MediaGrid({
  client,
  items,
  searching,
  onOpen,
}: {
  client: MatrixClient;
  items: SharedFile[];
  /** true — активен поиск/фильтр: пустой результат объясняем запросом. */
  searching: boolean;
  onOpen: (f: SharedFile) => void;
}) {
  const t = useT();
  const tfmt = useTF();
  if (items.length === 0) {
    return (
      <div style={st.hint} data-testid="profile-media-empty">
        {searching
          ? t("profile.noSearchResults")
          : t("profile.noMedia")}
      </div>
    );
  }
  return (
    <div>
      <div style={{ padding: `0 0 ${space.sm}px`, fontSize: font.small, color: color.textDim }}>
        {tfmt("profile.searchResults", { count: items.length })}
      </div>
      {groupByMonth(items).map(([label, group]) => (
        <div key={label}>
          <div style={ft.monthLabel}>{label}</div>
          <div style={ft.grid}>
            {group.map((f) => (
              <MediaTile key={f.eventId} client={client} item={f} onOpen={() => onOpen(f)} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/** Квадрат сетки: серверное превью; у видео — плашка длительности (как Tile в RoomTabs). */
function MediaTile({
  client,
  item,
  onOpen,
}: {
  client: MatrixClient;
  item: SharedFile;
  onOpen: () => void;
}) {
  // Превью сервера (thumbnail_url), если отправитель его вложил, — дешевле
  // всего. Иначе просим у сервера уменьшенную копию оригинала (/thumbnail).
  const { url } = useAuthedThumb(client, item.thumbMxc ?? item.mxc);
  return (
    <button
      type="button"
      onClick={onOpen}
      title={item.filename ?? item.name}
      data-testid="profile-media-tile"
      style={ft.tile}
    >
      {url ? (
        <img src={url} alt={item.filename ?? item.name} loading="lazy" style={ft.tileImg} />
      ) : (
        <span style={ft.tileStub} aria-hidden>
          {item.kind === "video" ? "▶" : "🖼"}
        </span>
      )}
    </button>
  );
}

/**
 * Таб «Файлы»: список строк — иконка типа, имя, размер, дата, комната,
 * скачивание (как FilesTab/FileRow в RoomTabs). Аудио попадает сюда же:
 * у кабинета два таба, а не пять — аудио не картинка, значит файл.
 */
function FilesList({
  client,
  items,
  searching,
  mine,
}: {
  client: MatrixClient;
  items: SharedFile[];
  searching: boolean;
  mine: boolean;
}) {
  const t = useT();
  const tfmt = useTF();
  if (items.length === 0) {
    return (
      <div style={st.hint} data-testid="profile-files-empty">
        {searching
          ? t("profile.noSearchResults")
          : mine
            ? t("profile.noOwnFiles")
            : t("profile.noOtherFiles")}
      </div>
    );
  }
  return (
    <div>
      <div style={{ padding: `0 0 ${space.sm}px`, fontSize: font.small, color: color.textDim }}>
        {tfmt("profile.searchResults", { count: items.length })}
      </div>
      {groupByMonth(items).map(([label, group]) => (
        <div key={label}>
          <div style={ft.monthLabel}>{label}</div>
          {group.map((f) => (
            <FileRow key={f.eventId} client={client} file={f} mine={mine} />
          ))}
        </div>
      ))}
    </div>
  );
}

/** Значок по расширению имени — как fileIconOf в MediaViewer/fileIcon в RoomTabs. */
function fileIconOf(name: string): string {
  const ext = name.toLowerCase().split(".").pop() ?? "";
  if (["pdf"].includes(ext)) return "📕";
  if (["doc", "docx", "rtf", "odt"].includes(ext)) return "📘";
  if (["xls", "xlsx", "csv", "ods"].includes(ext)) return "📗";
  if (["ppt", "pptx"].includes(ext)) return "📙";
  if (["zip", "rar", "7z", "gz", "tar"].includes(ext)) return "🗜";
  if (["mp3", "wav", "ogg", "flac", "m4a"].includes(ext)) return "🎵";
  if (["txt", "md", "log"].includes(ext)) return "📄";
  return "📎";
}

function FileRow({
  client,
  file,
  mine,
}: {
  client: MatrixClient;
  file: SharedFile;
  mine: boolean;
}) {
  const t = useT();
  const tfmt = useTF();
  const locale = useLocale();
  // Скачивание через авторизованный blob: прямая mxc-ссылка даст 401
  // (наш Synapse — authenticated media, см. шапку matrix/media.ts).
  const { url } = useAuthedMedia(client, file.mxc);
  const name = file.filename ?? file.name;
  // ДАТА ПО ЯЗЫКУ ИНТЕРФЕЙСА (решение Антона, фаза 2б): было жёсткое "ru-RU".
  const when = new Date(file.ts).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return (
    <a
      href={url ?? undefined}
      download={name}
      target="_blank"
      rel="noreferrer noopener"
      style={{
        ...ft.fileRow,
        cursor: url ? "pointer" : "default",
        opacity: url ? 1 : 0.6,
      }}
      title={url ? tfmt("media.downloadNamed", { name }) : t("ui.gotovlyu_fayl")}
      data-testid="profile-file-row"
    >
      <span style={{ fontSize: 20, flex: "0 0 auto" }} aria-hidden>
        {fileIconOf(name)}
      </span>
      <span style={{ minWidth: 0, flex: "1 1 auto" }}>
        <span style={ft.fileName} title={name}>
          {name}
        </span>
        <span style={ft.fileMeta}>
          {[
            file.size !== null ? formatSize(file.size) : null,
            when,
            file.roomName,
            !mine
              ? tfmt("profile.fileFrom", {
                  user: file.senderId.replace(/^@/, "").split(":")[0] ?? "",
                })
              : null,
          ]
            .filter(Boolean)
            .join(" · ")}
        </span>
      </span>
      <span style={{ color: color.accent, fontSize: 15, flex: "0 0 auto" }} aria-hidden>
        ⤓
      </span>
    </a>
  );
}

/**
 * Полноразмерный просмотр по клику на превью (постановка: «клик —
 * полноразмерный просмотр»). Свой минимальный лайтбокс, как у аватара:
 * один слайд, закрытие кликом по фону / крестиком / Esc. Карусель
 * MediaViewer здесь не нужна — медиа собраны из разных комнат, и
 * «листать дальше» по ним смысла не имеет.
 */
function MediaLightbox({
  client,
  file,
  onClose,
}: {
  client: MatrixClient;
  file: SharedFile;
  onClose: () => void;
}) {
  const t = useT();
  const tfmt = useTF();
  // Полноразмерный файл (не thumbnail) — один, поэтому трафик оправдан.
  const { url, error } = useAuthedMediaBlob(client, file.mxc);
  const name = file.filename ?? file.name;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      style={st.lightboxBackdrop}
      onClick={onClose}
      role="dialog"
      aria-label={name}
      data-testid="profile-media-lightbox"
    >
      <button
        type="button"
        style={st.lightboxClose}
        onClick={onClose}
        title={t("ui.zakryt_esc")}
        aria-label={t("common.close")}
        data-testid="profile-media-lightbox-close"
      >
        <IconClose size={22} />
      </button>
      {url ? (
        file.kind === "video" ? (
          <video
            src={url}
            controls
            autoPlay
            style={st.lightboxImg}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          // Тот же Zoomable, что и в MediaViewer, — второго механизма зума
          // в проекте нет (постановка Антона 2026-10-05).
          <Zoomable>
            <img
              src={url}
              alt={name}
              style={st.lightboxImg}
              draggable={false}
              onClick={(e) => e.stopPropagation()}
            />
          </Zoomable>
        )
      ) : (
        <div style={{ color: "#fff", fontSize: font.small }}>
          {error ? tfmt("profile.loadFailed", { error }) : t("room.loadingShort")}
        </div>
      )}
    </div>
  );
}

function formatSize(bytes: number): string {
  if (bytes < 1024) return tf("common.sizeBytes", { size: bytes });
  if (bytes < 1024 * 1024)
    return tf("common.sizeKb", { size: (bytes / 1024).toFixed(0) });
  return tf("common.sizeMb", { size: (bytes / (1024 * 1024)).toFixed(1) });
}

/** Стили раздела файлов — отдельно от st, чтобы не раздувать общий блок;
    токены те же (theme.ts), литеральных цветов нет. */
const ft = {
  strip: {
    display: "flex",
    borderBottom: `1px solid ${color.border}`,
    background: color.bg,
    marginBottom: space.md,
  } as CSSProperties,

  tabBtn: {
    flex: "1 1 0",
    padding: "10px 4px 8px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    font: "inherit",
    fontSize: font.small,
  } as CSSProperties,

  monthLabel: {
    padding: `${space.md}px 0 6px`,
    fontSize: font.small,
    color: color.textDim,
    letterSpacing: 0.4,
  } as CSSProperties,

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 2,
  } as CSSProperties,

  tile: {
    position: "relative",
    aspectRatio: "1 / 1",
    background: color.sidebarBg,
    overflow: "hidden",
    borderRadius: radius.sm,
    border: "none",
    padding: 0,
    cursor: "zoom-in",
  } as CSSProperties,

  tileImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  } as CSSProperties,

  tileStub: {
    width: "100%",
    height: "100%",
    display: "grid",
    placeItems: "center",
    fontSize: 20,
    color: color.textDim,
  } as CSSProperties,

  fileRow: {
    display: "flex",
    alignItems: "center",
    gap: space.md,
    padding: `9px 0`,
    borderBottom: `1px solid ${color.borderSoft}`,
    textDecoration: "none",
    color: color.text,
  } as CSSProperties,

  fileName: {
    display: "block",
    fontSize: font.small,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } as CSSProperties,

  fileMeta: {
    display: "block",
    fontSize: 11,
    color: color.textDim,
  } as CSSProperties,
} as const;

/* ------------------------------------------------------------------------
 * Раздел «Уведомления»
 * --------------------------------------------------------------------- */

function NotificationsSection({ permission: _permission }: { permission?: string }) {
  return (
    <div data-testid="profile-notifications">
      <NotificationControls inline />
    </div>
  );
}

/* ------------------------------------------------------------------------
 * «Выйти» — последняя строка кабинета (правка 12:26 п.2)
 * --------------------------------------------------------------------- */

/**
 * Логаут. Красная строка после всех разделов — ДЕЙСТВИЕ, а не шестая
 * карточка. Подтверждение — ИНЛАЙН, а не модальный диалог: второй клик
 * по тому же месту («Да, выйти») — это и есть осознанное подтверждение,
 * и оно не перекрывает экран затемнением ради одного вопроса. Первый
 * клик только меняет строку на вопрос; случайный одиночный клик ничего
 * не делает, и через 5 секунд без второго клика строка сама возвращается.
 */
function LogoutRow({ onLogout }: { onLogout: () => void | Promise<void> }) {
  const [confirming, setConfirming] = useState(false);
  // ВЫХОД ТЕПЕРЬ СЕТЕВОЕ ДЕЙСТВИЕ (25.09): завершение сессии в MAS.
  // Значит, у него есть два состояния, которых раньше быть не могло:
  // «идёт» и «не вышло». Оба обязаны быть видны: именно невидимость
  // результата и была жалобой «нажал и ничего не произошло».
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const t = useT();

  useEffect(() => {
    // Пока идёт выход или висит ошибка — СТРОКУ НЕ СБРАСЫВАЕМ.
    // Иначе сообщение об ошибке исчезло бы через 5 секунд самособой,
    // и человек снова остался бы с «ничего не произошло».
    if (!confirming || busy || error) return;
    const timer = window.setTimeout(() => setConfirming(false), 5000);
    return () => window.clearTimeout(timer);
  }, [confirming, busy, error]);

  const run = async () => {
    setBusy(true);
    setError(null);
    try {
      await onLogout();
      // Успешный выход заканчивается location.reload() в App — снимать
      // busy незачем и вредно: кнопка не должна оживать на мигновение.
    } catch (e) {
      setError(humanError(e));
      setBusy(false);
    }
  };

  if (confirming) {
    return (
      <div style={st.logoutConfirm} data-testid="profile-logout-confirm">
        <span style={st.logoutQuestion}>
          {busy ? t("profile.logoutProgress") : t("profile.logoutQuestion")}
        </span>
        {!busy && (
          <>
            <button
              type="button"
              style={st.logoutYes}
              onClick={run}
              data-testid="profile-logout-yes"
            >{error ? t("profile.logoutRetry") : t("profile.logoutConfirm")}</button>
            <button
              type="button"
              style={st.logoutNo}
              onClick={() => {
                setError(null);
                setConfirming(false);
              }}
              data-testid="profile-logout-no"
            >{t("common.cancel")}</button>
          </>
        )}
        {error && (
          <span role="alert" style={st.logoutError} data-testid="profile-logout-error">
            {error}
          </span>
        )}
      </div>
    );
  }

  return (
    <button
      type="button"
      style={st.logoutRow}
      onClick={() => setConfirming(true)}
      data-testid="profile-logout"
    >
      {t("profile.logout")}
    </button>
  );
}

/* ------------------------------------------------------------------------
 * Раздел «Оформление»
 * --------------------------------------------------------------------- */

function AppearanceSection() {
  const [mode, setMode] = useState<"system" | "light" | "dark">(() => readThemeMode());
  const [fontSize, setFontSize] = useState<FontSizeMode>(() => readFontSizeMode());
  const t = useT();

  const themeOptions = [
    { id: "system" as const, label: t("theme.system") },
    { id: "light" as const, label: t("theme.light") },
    { id: "dark" as const, label: t("theme.dark") },
  ];
  const fontSizeOptions = [
    { id: "small" as const, label: t("fontSize.small") },
    { id: "default" as const, label: t("fontSize.default") },
    { id: "large" as const, label: t("fontSize.large") },
  ];

  return (
    <div data-testid="profile-appearance">
      <div style={{ display: "flex", flexDirection: "column", gap: space.sm }}>
        {themeOptions.map((opt) => (
          <button
            key={opt.id}
            type="button"
            style={{
              display: "flex", alignItems: "center", gap: space.md,
              padding: `${space.md}px ${space.lg}px`, border: "none",
              borderRadius: radius.sm,
              background: mode === opt.id ? color.accentSoft : "transparent",
              color: mode === opt.id ? color.accent : color.text,
              font: "inherit", fontSize: font.body, cursor: "pointer", textAlign: "left",
            }}
            onClick={() => { setMode(opt.id); applyTheme(opt.id); }}
            data-testid={`profile-theme-${opt.id}`}
          >
            <span style={{ flex: "1 1 auto" }}>{opt.label}</span>
            {mode === opt.id && <span style={{ color: color.accent, fontWeight: font.weightBold }}>✓</span>}
          </button>
        ))}
      </div>
      <div style={{ marginTop: space.lg, marginBottom: space.sm, fontSize: font.small, fontWeight: font.weightBold, color: color.textDim }}>
        {t("fontSize.label")}
      </div>
      <div
        role="group"
        aria-label={t("fontSize.label")}
        style={{ display: "flex", flexDirection: "column", gap: space.sm }}
      >
        {fontSizeOptions.map((opt) => (
          <button
            key={opt.id}
            type="button"
            style={{
              display: "flex", alignItems: "center", gap: space.md,
              padding: `${space.md}px ${space.lg}px`, border: "none",
              borderRadius: radius.sm,
              background: fontSize === opt.id ? color.accentSoft : "transparent",
              color: fontSize === opt.id ? color.accent : color.text,
              font: "inherit", fontSize: font.body, cursor: "pointer", textAlign: "left",
            }}
            onClick={() => { setFontSize(opt.id); applyFontSize(opt.id); }}
            data-testid={`profile-font-size-${opt.id}`}
            aria-pressed={fontSize === opt.id}
          >
            <span style={{ flex: "1 1 auto" }}>{opt.label}</span>
            {fontSize === opt.id && <span style={{ color: color.accent, fontWeight: font.weightBold }}>✓</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Раздел «Язык»
 * --------------------------------------------------------------------- */

/**
 * Список языков из LANGS (src/i18n). Клик — setLang без перезагрузки:
 * useSyncExternalStore в useLang/useT перерисовывает кабинет сразу.
 */
function LanguageSection() {
  const { lang, setLang } = useLang();
  const t = useT();
  const flags: Record<(typeof LANGS)[number]["code"], string> = {
    ru: "🇷🇺",
    en: "🇬🇧",
    es: "🇪🇸",
    "pt-BR": "🇧🇷",
  };

  return (
    <div data-testid="profile-language">
      <style>{`
        .alg-language-flag:focus-visible {
          outline: 2px solid ${color.accent};
          outline-offset: 2px;
        }
      `}</style>
      <div
        role="group"
        aria-label={t("settings.language")}
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          gap: space.sm,
          maxWidth: "100%",
          overflowX: "auto",
          padding: 2,
        }}
      >
        {LANGS.map((l) => (
          <button
            key={l.code}
            type="button"
            className="alg-language-flag"
            style={{
              display: "grid",
              placeItems: "center",
              flex: "0 0 44px",
              width: 44,
              height: 38,
              alignItems: "center",
              padding: 0,
              border: lang === l.code
                ? `2px solid ${color.accent}`
                : `1px solid ${color.border}`,
              borderRadius: radius.sm,
              background: lang === l.code ? color.accentSoft : "transparent",
              color: color.text,
              font: "inherit",
              fontSize: 24,
              lineHeight: 1,
              cursor: "pointer",
            }}
            onClick={() => setLang(l.code)}
            aria-label={l.label}
            title={l.label}
            aria-pressed={lang === l.code}
            data-testid={`profile-lang-${l.code}`}
          >
            <span aria-hidden>{flags[l.code]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------------
 * Стили. Только токены из theme.ts — литеральный hex здесь дефект ревью
 * (правило из шапки theme.ts).
 * --------------------------------------------------------------------- */

const st = {
  main: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    minHeight: 0,
    background: color.feedBg,
    position: "relative",
  } as CSSProperties,

  topRow: {
    display: "flex",
    alignItems: "center",
    gap: space.md,
    padding: `10px ${space.xl}px`,
    borderBottom: `1px solid ${color.borderSoft}`,
    flex: "0 0 auto",
  } as CSSProperties,

  title: {
    fontSize: 15,
    fontWeight: font.weightBold,
    margin: 0,
  } as CSSProperties,

  iconBtn: {
    font: "inherit",
    width: 32,
    height: 32,
    borderRadius: radius.circle,
    border: "none",
    background: "transparent",
    color: color.textDim,
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  scroll: {
    flex: "1 1 auto",
    overflowY: "auto",
    minHeight: 0,
    padding: `${space.xl}px ${space.xl}px 32px`,
    maxWidth: 640,
  } as CSSProperties,

  errorBar: {
    padding: `${space.md}px ${space.lg}px`,
    marginBottom: space.lg,
    borderRadius: radius.sm,
    background: color.dangerBg,
    color: color.danger,
    fontSize: font.small,
  } as CSSProperties,

  /* Шапка: кружок СЛЕВА, текст СПРАВА. Горизонтальная раскладка — суть
     постановки п.1; вертикальная (фото сверху, имя под ним) и тем более
     оверлей были бы отклонены. */
  header: {
    display: "flex",
    alignItems: "center",
    gap: space.xl,
    marginBottom: space.xl,
  } as CSSProperties,

  avatarBtn: {
    flex: `0 0 ${AVATAR_SIZE}px`,
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    padding: 0,
    border: "none",
    background: "transparent",
    borderRadius: radius.circle,
    overflow: "hidden",
  } as CSSProperties,

  avatarImg: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: radius.circle,
    objectFit: "cover",
    display: "block",
  } as CSSProperties,

  avatarStub: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: radius.circle,
    display: "grid",
    placeItems: "center",
    color: color.textOnAccent,
    fontSize: 36,
    fontWeight: font.weightBold,
    userSelect: "none",
  } as CSSProperties,

  nameBtn: {
    font: "inherit",
    padding: 0,
    border: "none",
    background: "transparent",
    color: color.text,
    cursor: "text",
    textAlign: "left",
  } as CSSProperties,

  nameText: {
    fontSize: 20,
    fontWeight: font.weightBold,
    lineHeight: 1.3,
    /* overflow-wrap ВМЕСТО word-break:break-word (баг 21.09): разница видна
       именно на узкой колонке. overflow-wrap рвёт слово только когда
       оно ЦЕЛИКОМ не влезает в строку, сначала перенося его целиком;
       word-break:break-word в тех же условиях охотнее режет по буквам,
       из-за чего короткое имя «ab» на скриншоте Антона разъехалось на
       две строки. Перенос длинных имён сохраняется — вёрстка не течёт. */
    overflowWrap: "break-word",
    wordBreak: "normal",
  } as CSSProperties,

  mxid: {
    marginTop: space.xs,
    fontSize: font.small,
    color: color.textDim,
    fontFamily: font.mono,
    /* АДРЕС БОЛЬШЕ НЕ ЛОМАЕТСЯ ПОСИМВОЛЬНО (баг Антона 21.09).
       Было `word-break: break-all` — он режет строку на ЛЮБОМ символе
       ВСЕГДА, не пытаясь сначала уложить слово. На широкой колонке
       это не видно (адрес и так влезал в одну строку), а когда колонка
       сжалась до 34px — дало те самые семь строк почти по букве.
       `overflow-wrap: anywhere` рвёт тОЛЬКО когда иначе будет переполнение,
       и сохраняет главное свойство break-all: длинный MXID всё равно
       не вылезет за край и не распирает панель. */
    overflowWrap: "anywhere",
    wordBreak: "normal",
  } as CSSProperties,

  nameInput: {
    font: "inherit",
    fontSize: 17,
    fontWeight: font.weightBold,
    padding: `${space.sm}px ${space.md}px`,
    borderRadius: radius.sm,
    border: `1px solid ${color.borderStrong}`,
    background: color.bg,
    color: color.text,
    minWidth: 0,
    flex: "1 1 auto",
  } as CSSProperties,

  smallBtn: {
    font: "inherit",
    width: 30,
    height: 30,
    flex: "0 0 30px",
    borderRadius: radius.sm,
    border: "none",
    background: color.accent,
    color: color.textOnAccent,
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  smallBtnGhost: {
    font: "inherit",
    width: 30,
    height: 30,
    flex: "0 0 30px",
    borderRadius: radius.sm,
    border: `1px solid ${color.border}`,
    background: color.bg,
    color: color.textDim,
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  /* «Изменить фото» — акцентная строка: мягкий акцентный фон, акцентный
     текст и иконка. НЕ сплошная красная заливка: рядом пять нейтральных
     карточек, и одна кричащая кнопка превратила бы шапку в рекламный
     баннер. accentSoft — тот же приём, что у активной строки списка. */
  photoRow: {
    display: "flex",
    alignItems: "center",
    gap: space.lg,
    width: "100%",
    boxSizing: "border-box",
    padding: `${space.lg}px ${space.xl}px`,
    border: "none",
    borderRadius: radius.md,
    background: color.accentSoft,
    color: color.accent,
    font: "inherit",
    fontSize: font.body,
    fontWeight: font.weightBold,
    cursor: "pointer",
    textAlign: "left",
  } as CSSProperties,

  photoRowIcon: {
    flex: "0 0 auto",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  photoRowLabel: {
    flex: "1 1 auto",
    minWidth: 0,
  } as CSSProperties,

  cards: {
    display: "flex",
    flexDirection: "column",
    gap: space.md,
  } as CSSProperties,

  card: {
    background: color.bg,
    border: `1px solid ${color.border}`,
    borderRadius: radius.md,
    overflow: "hidden",
  } as CSSProperties,

  cardHead: {
    display: "flex",
    alignItems: "center",
    gap: space.lg,
    width: "100%",
    boxSizing: "border-box",
    padding: `${space.lg}px ${space.xl}px`,
    border: "none",
    background: "transparent",
    font: "inherit",
    fontSize: font.body,
    color: color.text,
    textAlign: "left",
    cursor: "pointer",
  } as CSSProperties,

  cardIcon: {
    flex: "0 0 auto",
    display: "grid",
    placeItems: "center",
    color: color.textDim,
  } as CSSProperties,

  cardLabel: {
    flex: "1 1 auto",
    minWidth: 0,
    /* Подписи разделов переносятся на вторую строку, а НЕ обрезаются
       (баг 21.09: «Устройст...», «Файлы и медиа, которым поделил...»).
       Обрезка шла не от text-overflow — его здесь нет вовсе, а от того,
       что карточка (st.card) имеет overflow:hidden, а сама кнопка была
       уже текста. После починки ширины подписи влезают; это правило —
       страховка для самых узких экранов и длинных переводов. */
    overflowWrap: "break-word",
  } as CSSProperties,

  cardValue: {
    flex: "0 0 auto",
    fontSize: font.small,
    color: color.textDim,
    whiteSpace: "nowrap",
  } as CSSProperties,

  cardChevron: {
    flex: "0 0 auto",
    display: "grid",
    placeItems: "center",
    color: color.textMuted,
    transition: "transform 120ms ease-out",
  } as CSSProperties,

  cardBody: {
    borderTop: `1px solid ${color.borderSoft}`,
    padding: `${space.lg}px ${space.xl}px`,
  } as CSSProperties,

  hint: {
    fontSize: font.small,
    color: color.textDim,
    lineHeight: 1.5,
  } as CSSProperties,

  errorText: {
    fontSize: font.small,
    color: color.danger,
    lineHeight: 1.4,
  } as CSSProperties,

  deviceRow: {
    display: "flex",
    alignItems: "center",
    gap: space.lg,
    padding: `${space.lg}px ${space.lg}px`,
    width: "100%",
    boxSizing: "border-box",
    border: "none",
    background: "transparent",
    font: "inherit",
    color: color.text,
    textAlign: "left",
    cursor: "pointer",
  } as CSSProperties,

  /* Стили сессий (deviceSessions / deviceSessionsHint) СЕЙЧАС НЕ
     ИСПОЛЬЗУЮТСЯ: список сессий убран с экрана (Антон 24.09/25.09).
     Оставлены намеренно — вместе с SessionRow, для будущего админского
     экрана. tsc на них не ругается: это свойства объекта st, а не
     отдельные объявления под noUnusedLocals. sessionRow ниже ещё
     используется — его берёт строка подтверждения удаления устройства. */
  deviceSessions: {
    borderTop: `1px solid ${color.borderSoft}`,
    padding: `${space.sm}px 0`,
  } as CSSProperties,

  deviceSessionsHint: {
    fontSize: font.micro,
    color: color.textDim,
    padding: `${space.xs}px ${space.lg}px`,
    lineHeight: 1.5,
  } as CSSProperties,

  sessionRow: {
    display: "flex",
    alignItems: "center",
    gap: space.md,
    padding: `${space.sm}px ${space.lg}px`,
  } as CSSProperties,

  deviceIcon: {
    flex: "0 0 auto",
    display: "grid",
    placeItems: "center",
    color: color.textDim,
  } as CSSProperties,

  deviceName: {
    fontSize: font.body,
    color: color.text,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as CSSProperties,

  deviceCurrent: {
    color: color.ok,
    fontSize: font.small,
  } as CSSProperties,

  deviceMeta: {
    fontSize: font.micro,
    color: color.textDim,
    marginTop: 1,
  } as CSSProperties,

  deviceRenameBtn: {
    flex: "0 0 auto",
    font: "inherit",
    width: 28,
    height: 28,
    borderRadius: radius.sm,
    border: "none",
    background: "transparent",
    color: color.textDim,
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  /* Кнопка удаления устройства — кирпичный danger, а НЕ фирменный
     accent: «удалить» обязано отличаться от «позвонить» (шапка theme.ts,
     цвета состояний). */
  deviceDeleteBtn: {
    flex: "0 0 auto",
    font: "inherit",
    width: 28,
    height: 28,
    borderRadius: radius.sm,
    border: "none",
    background: "transparent",
    color: color.danger,
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  } as CSSProperties,

  /* «Добавить устройство» — акцентная строка в духе «Изменить фото»,
     но внутри раздела: мягкий акцентный фон, не сплошной красный. */
  deviceAddBtn: {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    marginTop: space.lg,
    padding: `${space.lg}px ${space.xl}px`,
    border: "none",
    borderRadius: radius.md,
    background: color.accentSoft,
    color: color.accent,
    font: "inherit",
    fontSize: font.body,
    fontWeight: font.weightBold,
    cursor: "pointer",
    textAlign: "left",
  } as CSSProperties,

  /* Баннер «новое устройство» — заметный, но не паника: warn-палитра
     (янтарь), а не danger. Danger оставлен разрушительным действиям. */
  newDeviceBanner: {
    padding: `${space.md}px ${space.lg}px`,
    marginBottom: space.lg,
    borderRadius: radius.sm,
    background: color.warnBg,
    border: `1px solid ${color.warnBorder}`,
    color: color.warn,
    fontSize: font.small,
    lineHeight: 1.5,
  } as CSSProperties,

  deviceNameInput: {
    font: "inherit",
    fontSize: font.body,
    padding: `${space.sm}px ${space.md}px`,
    borderRadius: radius.sm,
    border: `1px solid ${color.borderStrong}`,
    background: color.bg,
    color: color.text,
    minWidth: 0,
    flex: "1 1 auto",
  } as CSSProperties,

  deviceResetBtn: {
    font: "inherit",
    fontSize: font.micro,
    marginTop: space.sm,
    padding: 0,
    border: "none",
    background: "transparent",
    color: color.textDim,
    textDecoration: "underline",
    cursor: "pointer",
  } as CSSProperties,

  deviceCard: {
    background: color.bg,
    border: `1px solid ${color.border}`,
    borderRadius: radius.md,
    overflow: "hidden",
  } as CSSProperties,

  /* Строка поиска раздела «Файлы и медиа» (Антон 12.09 18:00). */
  searchInput: {
    font: "inherit",
    fontSize: font.body,
    color: color.text,
    width: "100%",
    boxSizing: "border-box",
    padding: `${space.md}px ${space.lg}px`,
    marginBottom: space.sm,
    borderRadius: radius.sm,
    border: `1px solid ${color.borderStrong}`,
    background: color.bg,
  } as CSSProperties,

  /* Фильтр по комнате-источнику. */
  roomSelect: {
    font: "inherit",
    fontSize: font.small,
    color: color.text,
    width: "100%",
    boxSizing: "border-box",
    padding: `${space.sm}px ${space.md}px`,
    marginBottom: space.md,
    borderRadius: radius.sm,
    border: `1px solid ${color.border}`,
    background: color.bg,
  } as CSSProperties,

  /* Лайтбокс: тот же закон, что у MediaViewer — затемнение через токен
     backdrop, фото по центру, крестик справа сверху. */
  lightboxBackdrop: {
    position: "fixed",
    inset: 0,
    background: color.backdrop,
    display: "grid",
    placeItems: "center",
    zIndex: 70,
  } as CSSProperties,

  lightboxImg: {
    maxWidth: "92vw",
    maxHeight: "92vh",
    objectFit: "contain",
    borderRadius: radius.md,
  } as CSSProperties,

  lightboxClose: {
    position: "fixed",
    top: space.xl,
    right: space.xl,
    width: 40,
    height: 40,
    borderRadius: radius.circle,
    border: "none",
    background: "rgba(0,0,0,0.45)",
    color: "#fff",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    zIndex: 71,
  } as CSSProperties,

  /* «Выйти» — красная строка-действие (правка 12:26 п.2). НЕ карточка:
     список разделов закрыт, и логаут не должен читаться шестым пунктом. */
  /** Строка с текущим сервером над «Выйти»: нейтральная, не красная —
      смена сервера не разрушительная и не теряет сессию. */
  serverRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: space.md,
    width: "100%",
    boxSizing: "border-box",
    marginTop: space.xl,
    padding: `${space.lg}px ${space.xl}px`,
    border: `1px solid ${color.border}`,
    borderRadius: radius.md,
    background: "transparent",
    color: color.text,
    font: "inherit",
    fontSize: font.body,
    textAlign: "left",
    cursor: "pointer",
  } as CSSProperties,

  serverRowHost: {
    display: "block",
    marginTop: 2,
    color: color.textDim,
    fontSize: font.small,
  } as CSSProperties,

  serverRowAction: {
    color: color.accent,
    fontSize: font.small,
    whiteSpace: "nowrap",
  } as CSSProperties,

  logoutRow: {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    marginTop: space.md,
    padding: `${space.lg}px ${space.xl}px`,
    border: "none",
    borderRadius: radius.md,
    background: "transparent",
    color: color.danger,
    font: "inherit",
    fontSize: font.body,
    fontWeight: font.weightBold,
    textAlign: "left",
    cursor: "pointer",
  } as CSSProperties,

  logoutError: {
    // Ошибка выхода — рядом с кнопкой, тем же красным, без сокращения
    // текста: причина важнее компактности.
    color: color.danger,
    fontSize: 13,
    lineHeight: 1.35,
    flexBasis: "100%",
  },
  logoutConfirm: {
    display: "flex",
    alignItems: "center",
    gap: space.md,
    flexWrap: "wrap",
    marginTop: space.xl,
    padding: `${space.lg}px ${space.xl}px`,
    borderRadius: radius.md,
    background: color.dangerBg,
  } as CSSProperties,

  logoutQuestion: {
    flex: "1 1 auto",
    minWidth: 200,
    fontSize: font.body,
    color: color.danger,
  } as CSSProperties,

  logoutYes: {
    font: "inherit",
    fontSize: font.small,
    fontWeight: font.weightBold,
    padding: `${space.md}px ${space.lg}px`,
    borderRadius: radius.sm,
    border: "none",
    background: color.danger,
    color: color.textOnAccent,
    cursor: "pointer",
  } as CSSProperties,

  logoutNo: {
    font: "inherit",
    fontSize: font.small,
    padding: `${space.md}px ${space.lg}px`,
    borderRadius: radius.sm,
    border: `1px solid ${color.border}`,
    background: color.bg,
    color: color.text,
    cursor: "pointer",
  } as CSSProperties,
} as const;
